
export enum Approach {
  TCC = "Terapia Cognitivo-Comportamental (TCC)",
  ACT = "Terapia de Aceitação e Compromisso (ACT)",
  DBT = "Terapia Dialética Comportamental (DBT)",
  FREUD = "Psicanálise Freudiana",
  JUNG = "Psicologia Analítica (Jung)",
  PSICODINAMICA = "Psicodinâmica Breve",
  WINNICOTT = "Psicanálise Winnicottiana",
  LACAN = "Psicanálise Lacaniana",
  ROGERS = "Abordagem Centrada na Pessoa (Rogers)",
  GESTALT = "Gestalt-terapia",
  LOGOTERAPIA = "Logoterapia",
  MINUCHIN = "Terapia Familiar Estrutural (Minuchin)",
  SISTEMICA = "Terapia Sistêmica Breve",
  NARRATIVA = "Terapia Narrativa",
  CASAL = "Terapia de Casal",
  TBS = "Terapia Breve Focada na Solução (TBS)",
  ESTRATEGICA = "Terapia Estratégica",
  ABA = "Análise do Comportamento / Behaviorismo (ABA)",
  HIPNOSE = "Hipnose Clínica & Terapia Hipnoterápica"
}

export type IndicatorType = 'positive' | 'negative';

export enum CycleFrequency {
  MENSAL = "Mensal",
  BIMESTRAL = "Bimestral",
  TRIMESTRAL = "Trimestral",
  QUADRIMESTRAL = "Quadrimestral",
  SEMESTRAL = "Semestral",
  ANUAL = "Anual"
}

export interface Indicator {
  id: string;
  nome: string;
  dominio: string;
  eixo: IndicatorType;
  descricao_clinica: string;
  interpretacao: string;
  tags_teoricas: string[];
}

export interface CycleScore {
  indicatorId: string;
  score: number; // 0 to 10
}

export interface AudioAnalysis {
  id: string;
  date: string;
  recordingName: string;
  approach: Approach;
  transcription: string;
  sessionSynthesis: string;
  strategicPlan: string;
  profileSummary: string;
  indicatorScores: Record<string, number>;
}

export interface ClinicalCycle {
  id: string;
  date: string;
  approach: Approach;
  scores: CycleScore[];
  clinicalNotes: string;
  aiInsight?: string;
  patientReport?: string;
  evolutionGuidelines?: string;
  functionalImpairment: number;
  subjectiveDistress: number;
  copingResources: number;
}

export interface Medication {
  name: string;
  quantity: string;
  time: string;
}

export interface ClinicalRecord {
  id: string;
  date: string;
  content: string;
  approach?: Approach;
  aiAnalysis?: string;
  createdAt: string;
}

export interface PatientFile {
  id: string;
  name: string;
  url: string;
  type: string;
  size: string;
  uploadedAt: string;
}

export interface Patient {
  id: string;
  name: string;
  age?: string;
  phone?: string;
  dob?: string;
  email?: string;
  emergencyContact?: string;
  emergencyPhone?: string;
  address?: string;
  cep?: string;
  cpf?: string;
  fatherName?: string;
  motherName?: string;
  assignedProfessionalId?: string;
  assignedProfessionalName?: string;
  mainComplaint?: string;
  /**
   * No formulário é uma lista; a API persiste e devolve como texto único
   * (ver `normalizeMedications`). Os componentes tratam os dois formatos.
   */
  medications?: Medication[] | string;
  activeApproach: Approach;
  cycleFrequency: CycleFrequency;
  selectedIndicatorIds: string[]; 
  cycles: ClinicalCycle[];
  audioAnalyses?: AudioAnalysis[];
  records?: ClinicalRecord[];
  files?: PatientFile[];
  createdAt: string;
  status?: 'Ativo' | 'Inativo';
}

export interface Therapist {
  name: string;
  crp: string;
  clinicName: string;
  logo?: string;
  phone?: string;
  email?: string;
  website?: string;
  address?: string;
  cnpj?: string;
  professionalPhoto?: string;
  /** Bloco #45: WhatsApp pessoal ("Identidade do Profissional"). */
  whatsapp?: string;
  /** Bloco #45: WhatsApp da clínica ("Contato e Localização"). */
  clinicWhatsapp?: string;
}

export enum AlertType {
  PIORA_SUSTENTADA = "Piora Sustentada",
  ESTAGNACAO = "Estagnação Prolongada",
  OSCILACAO = "Oscilação Importante",
  BAIXO_ENGAJAMENTO = "Baixo Engajamento",
  ALTA_SUSTENTADA = "Alta Sustentada",
  RISCO_FUNCIONAL = "Risco Funcional"
}

export interface ClinicalAlert {
  type: AlertType;
  description: string;
  patientId: string;
  patientName: string;
  severity: 'low' | 'medium' | 'high';
}

export enum SubscriptionPlan {
  FREE_TRIAL = "Teste Gratuito",
  MONTHLY = "Plano Mensal",
  ANNUAL = "Plano Anual"
}

export enum SubscriptionStatus {
  TRIAL = "trial",
  ACTIVE = "active",
  EXPIRED = "expired",
  GRACE_PERIOD = "grace_period"
}

export interface SubscriptionInfo {
  plan: SubscriptionPlan;
  status: SubscriptionStatus;
  startDate: string;
  endDate: string;
  trialStartDate?: string;
  trialEndDate?: string;
  lastPaymentDate?: string;
  isAutoRenew: boolean;
  retentionUntil?: string;
}
